import { BaseResource } from "./BaseResource";
import { apiResourceUrl } from "@ploy-lib/core";
export class UnrecognizedEmailResource extends BaseResource {
    pk() {
        return this.id?.toString();
    }
}
UnrecognizedEmailResource.urlRoot = apiResourceUrl("unrecognized-email/{id}");
//# sourceMappingURL=UnrecognizedEmailResource.js.map